export const HEADING = 'Open offerings';

export const SUBHEADER =
  'Funds, businesses, real estate, culture assets, and more.';
export const GROWTH_STAGE_VENTURES_ANCHOR_ID = 'growth-stage-ventures';
